import { Component, OnInit, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { LoginService } from '../login/login.service';
import { User } from '../models/user';
import { MsjDialogService } from '../service/msjDialogService';
import { UserService } from '../service/user.service';
import { ParameterConst } from '../util/constant';

@Component({
  selector: 'wr-change-password',
  templateUrl: './change.component.html',
  styleUrls: ['./change.component.css'],
})
export class PasswordComponent implements OnInit {
  passwordForm: FormGroup;
  welcome;
  nombreRol;
  date: Date;
  menus = [];
  @Input() public linkActive: string;

  constructor(
    private router: Router,
    private userService: UserService,
    private msjSnackBar: MsjDialogService
  ) {
    this.setChangePasswordForm();
  }

  setChangePasswordForm() {
    this.passwordForm = new FormGroup({
      access: new FormControl('', [Validators.required]),
    });
  }

  ngOnInit() {}

  changePassword() {
    let access = this.passwordForm.value.access;
    let user = JSON.parse(localStorage.getItem(ParameterConst.USER_LOGIN));
    let hash = user.keyhash;

    this.userService
      .changePassword(access, hash)
      .pipe()
      .subscribe(
        (result) => {
          if (result == 1) {
            this.msjSnackBar.openMensaje(
              'Contraseña Cambiada con éxito.',
              ParameterConst.MESSAGE_SERFOR
            );
          } else {
            this.msjSnackBar.openMensaje(
              'Vuelva a intentarlo.',
              ParameterConst.MESSAGE_SERFOR
            );
          }
        },
        (error) => {
          this.msjSnackBar.openMensaje(
            ParameterConst.API_DISCONNET,
            ParameterConst.MESSAGE_SERFOR
          );
        }
      );
  }

  backDasboard() {
    this.router.navigate(['/admin/dashboard']);
  }
}
